export default __webpack_public_path__ + "static/media/ghostlight.66e49112.png";